export const ACCOUNTS = [
    { value: 'CCO', title: 'Ahorro Obligatorio' },
    { value: 'CCV', title: 'APV - Ahorro Previsional Voluntario ' },
    { value: 'CAV', title: 'Cuenta 2 - Ahorro Voluntario' },
    { value: 'CAI', title: 'Cuenta de Indemnización' },
    { value: 'CDC', title: 'Depósito Convenido' },
    { value: 'CAF', title: 'Afiliado Voluntario' },
    { value: 'CVC', title: 'APVC - Ahorro Previsional Voluntario Colectivo' },
  ];

  export const storageTramitePension = {
    institucionSalud: 'institucionSalud',
    institucionesSalud: 'institucionesSalud',
  }